export const ID_PERFIL_ADMIN_EBP = 2
export const ID_PERFIL_PARTICULAR = 3
export const ID_PERFIL_ADMIN_EMPRESA = 4
export const ID_PERFIL_COMPRADOR = 5
export const ID_PERFIL_VENDEDOR = 6

export const TYC_ACEPTADO = 1
export const TYC_NO_ACEPTADO = 0

export const PERFILES_COMPRADOR = [
  ID_PERFIL_COMPRADOR,
  ID_PERFIL_PARTICULAR,
  ID_PERFIL_ADMIN_EMPRESA,
  ID_PERFIL_ADMIN_EBP
]

export const PERFILES_VENDEDOR = [
  ID_PERFIL_VENDEDOR,
  ID_PERFIL_PARTICULAR,
  ID_PERFIL_ADMIN_EMPRESA,
  ID_PERFIL_ADMIN_EBP
]
